"use client";
import { jsx as e, Fragment as l } from "react/jsx-runtime";
import { createSvgIcon as o } from "@mui/material/utils";
const i = o(
  /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37256 0 0 5.37259 0 12C0 18.6274 5.37256 24 12 24ZM12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8C9.79083 8 8 9.79086 8 12C8 14.2091 9.79083 16 12 16Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxRadioButtonFilled"
);
export {
  i as default
};
